import React, { useState, useSyncExternalStore } from 'react';
import { FiWifi, FiWifiOff } from 'react-icons/fi';
import { getCallStats, subscribeCallStats } from './callStatsStore';

const levelColor = {
  good: 'bg-emerald-500',
  fair: 'bg-amber-400',
  poor: 'bg-rose-500',
};

/** Compact live-quality chip — only this leaf re-renders on stats updates. */
export const CallStatsChip = ({ compact = false }) => {
  const stats = useSyncExternalStore(subscribeCallStats, getCallStats, getCallStats);
  const [open, setOpen] = useState(false);
  const color = levelColor[stats.level] || levelColor.good;

  if (compact) {
    return (
      <span
        className={`inline-block w-2 h-2 rounded-full ${color}`}
        title={`Connection: ${stats.level}`}
      />
    );
  }

  return (
    <div className="relative">
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="inline-flex items-center gap-1.5 rounded-full bg-white/10 hover:bg-white/20 text-white text-xs px-2.5 py-1 transition-colors"
        title="Connection quality"
      >
        {stats.level === 'poor' ? <FiWifiOff size={12} /> : <FiWifi size={12} />}
        <span className={`w-1.5 h-1.5 rounded-full ${color}`} />
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-2 w-48 rounded-xl bg-slate-950/95 border border-white/15 text-white text-xs p-3 shadow-xl z-40 space-y-1.5">
          <p className="font-medium capitalize">Quality: {stats.level}</p>
          <p className="text-white/70">Uplink: {stats.uplink || '—'} / Downlink: {stats.downlink || '—'}</p>
          {stats.bitrate != null && <p className="text-white/70">Bitrate: {Math.round(stats.bitrate)} kbps</p>}
          {stats.rtt != null && <p className="text-white/70">RTT: {Math.round(stats.rtt)} ms</p>}
          {stats.packetLoss != null && (
            <p className="text-white/70">Packet loss: {(Number(stats.packetLoss) * 100).toFixed(1)}%</p>
          )}
          {stats.resolution && <p className="text-white/70">Resolution: {stats.resolution}</p>}
        </div>
      )}
    </div>
  );
};
